import React, { useState, useEffect } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer'; 
import '../App.css';

const MechanicDashboard = () => {
  const [requests, setRequests] = useState([]);
  const [history, setHistory] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const [profileData, setProfileData] = useState({ name: '', phone: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;

  const fetchRequests = async () => {
    try {
      const res = await API.get('/requests/pending');
      setRequests(res.data);
    } catch (err) { console.error("Error fetching pending requests:", err); }
  };

  const fetchHistory = async () => {
    try {
      if (user) {
        const res = await API.get(`/requests/mechanic-history/${user.id}`);
        setHistory(res.data);
      }
    } catch (err) { console.error("Error fetching history:", err); }
  };

  useEffect(() => {
    if (user) {
      setProfileData({ name: user.name, phone: user.phone || '' });
      fetchRequests();
      fetchHistory();
    }
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await API.put(`/requests/update/${id}`, { status, mechanicId: user.id });
      alert(`Request marked as ${status}!`);
      fetchRequests(); 
      fetchHistory();  
      setSelectedRequest(null); 
    } catch (err) { alert("Update failed."); }
  };

  const updateProfile = async (e) => {
    e.preventDefault();
    try {
      const res = await API.put(`/auth/update-profile/${user.id}`, profileData);
      localStorage.setItem('user', JSON.stringify({ ...user, ...res.data }));
      alert("Profile updated successfully!");
    } catch (err) { alert("Failed to update profile."); }
  };

  const completedJobsCount = history.filter(h => h.status === 'Completed').length;
  const activeJobsCount = history.filter(h => h.status === 'Accepted').length;

  const filteredHistory = history.filter(h => {
    const matchesSearch = h.userId?.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          h.problemType?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || h.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <>
      <Navbar />
      <div className="container">
        
        {/* PROFILE SECTION */}
        <div className="card" style={{ marginBottom: '30px', borderTop: '4px solid var(--success)' }}>
          <h3>Mechanic Profile</h3>
          <form onSubmit={updateProfile} style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label><small><strong>Your Name</strong></small></label>
              <input type="text" value={profileData.name} onChange={(e) => setProfileData({...profileData, name: e.target.value})} style={{ margin: 0 }} />
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label><small><strong>Contact Number</strong></small></label>
              <input type="text" value={profileData.phone} onChange={(e) => setProfileData({...profileData, phone: e.target.value})} style={{ margin: 0 }} />
            </div>
            <button type="submit" className="btn-success">Update Profile</button>
          </form>
        </div>

        {/* STATS BAR */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
          <div className="card" style={{ flex: 1, textAlign: 'center', borderTop: '4px solid #28a745' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#666' }}>Jobs Completed</h4>
            <h2 style={{ margin: 0, color: '#28a745' }}>{completedJobsCount}</h2>
          </div>
          <div className="card" style={{ flex: 1, textAlign: 'center', borderTop: '4px solid #007bff' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#666' }}>Active Jobs</h4>
            <h2 style={{ margin: 0, color: '#007bff' }}>{activeJobsCount}</h2>
          </div>
        </div>

        <h2 style={{ marginBottom: '20px' }}>New Service Requests Feed</h2>
        {requests && requests.length > 0 ? (
          /* FIXED SORTING: Newest requests at the top based on Date */
          [...requests]
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map(req => (
              <div key={req._id} className="card" style={{ borderLeft: '5px solid #007bff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h4 style={{ margin: '0 0 10px 0' }}>{req.problemType} — {req.vehicleType}</h4>
                    <p>📍 {req.location}</p>
                    <p>📞 {req.phone} ({req.userId?.name || 'Customer'})</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <button className="btn-success" onClick={() => updateStatus(req._id, 'Accepted')}>Accept</button>
                    <button className="btn-danger" onClick={() => updateStatus(req._id, 'Declined')}>Decline</button>
                  </div>
                </div>
              </div>
            ))
        ) : (
          <div className="card"><p>No pending requests.</p></div>
        )}

        {/* WORK HISTORY TABLE */}
        <div className="card" style={{ marginTop: '40px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <h3 style={{ margin: 0 }}>My Work History</h3>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input type="text" placeholder="Search..." onChange={(e) => setSearchTerm(e.target.value)} />
              <select onChange={(e) => setStatusFilter(e.target.value)}>
                <option value="All">All Status</option>
                <option value="Accepted">Accepted</option>
                <option value="Completed">Completed</option>
                <option value="Declined">Declined</option>
              </select>
            </div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #ddd', textAlign: 'left' }}>
                <th style={{ padding: '10px' }}>Issue</th>
                <th style={{ padding: '10px' }}>Status</th>
                <th style={{ padding: '10px' }}>Date</th>
                <th style={{ padding: '10px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredHistory && filteredHistory.length > 0 ? (
                /* FIXED SORTING: Explicitly sort history by Date (Newest First) */
                [...filteredHistory]
                  .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  .map((h) => (
                    <tr key={h._id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '10px' }}>{h.problemType} ({h.vehicleType})</td>
                      <td style={{ padding: '10px' }}>
                        <span style={{ 
                          color: h.status === 'Completed' ? '#28a745' : h.status === 'Declined' ? '#dc3545' : '#007bff', 
                          fontWeight: 'bold' 
                        }}>
                          {h.status}
                        </span>
                      </td>
                      <td style={{ padding: '10px' }}>{new Date(h.createdAt).toLocaleDateString('en-IN')}</td>
                      <td style={{ padding: '10px', display: 'flex', gap: '5px' }}>
                        <button className="btn-outline-gray" onClick={() => setSelectedRequest(h)}>Details</button>
                        {h.status === 'Accepted' && (
                          <button className="btn-primary" style={{ padding: '5px 10px', fontSize: '12px' }} onClick={() => updateStatus(h._id, 'Completed')}>Mark Completed</button>
                        )}
                      </td>
                    </tr>
                  ))
              ) : (
                <tr><td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>No history found.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* DETAILS MODAL */}
        {selectedRequest && (
          <div className="modal-overlay" onClick={() => setSelectedRequest(null)}>
            <div className="modal-content card" onClick={(e) => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                <h3 style={{ margin: 0 }}>Customer Info</h3>
                <button style={{ background: 'none', border: 'none', fontSize: '24px' }} onClick={() => setSelectedRequest(null)}>×</button>
              </div>
              <div style={{ lineHeight: '1.8' }}>
                <p><strong>Customer:</strong> {selectedRequest.userId?.name || 'Customer'}</p>
                <p><strong>Mobile No:</strong> {selectedRequest.phone}</p>
                <p><strong>Location:</strong> {selectedRequest.location}</p>
                
                {selectedRequest.lat && selectedRequest.lng && (
                  <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${selectedRequest.lat},${selectedRequest.lng}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                      <button className="btn-primary" style={{ width: '100%', padding: '10px', background: '#4285F4' }}>🚗 Open Navigation</button>
                    </a>
                  </div>
                )}

                <p><strong>Problem:</strong> {selectedRequest.problemType}</p>
                <p><strong>Vehicle:</strong> {selectedRequest.vehicleType}</p>
                <p><strong>Date:</strong> {new Date(selectedRequest.createdAt).toLocaleString('en-IN')}</p>
                
                {selectedRequest.status === 'Accepted' && (
                  <button className="btn-success" style={{ width: '100%', marginTop: '15px', padding: '10px' }} onClick={() => updateStatus(selectedRequest._id, 'Completed')}>
                    ✅ Job Finished - Mark Completed
                  </button>
                )}
              </div>
              <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <button className="btn-danger" onClick={() => setSelectedRequest(null)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MechanicDashboard;